import styled from 'styled-components';
export const IconStyled = styled('span')(({ theme, size, color, onClick, }) => {
    var _a, _b, _c, _d;
    return ({
        display: 'inline-flex',
        width: 'auto',
        ...onClick && {
            cursor: 'pointer',
        },
        ...color && {
            color: (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _a === void 0 ? void 0 : _a[color]) === null || _b === void 0 ? void 0 : _b.base,
            'path[stroke=white]': {
                stroke: (_d = (_c = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _c === void 0 ? void 0 : _c[color]) === null || _d === void 0 ? void 0 : _d.contrastText,
            },
        },
        svg: {
            ...size && {
                xs: {
                    height: '8px',
                    width: 'unset',
                },
                s: {
                    height: '16px',
                    width: 'unset',
                },
                m: {
                    height: '24px',
                    width: 'unset',
                },
                l: {
                    height: '32px',
                    width: 'unset',
                },
            }[size],
        },
    });
});
//# sourceMappingURL=Icon.styles.js.map